const e = {
  name: "Toilet",
  dimensions: { width: 26, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 26 40" style="enable-background:new 0 0 26 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M10,0H0v21h0c0.3,3.8,2.2,7.2,5.2,9.4L0,35.6V40h26v-4.4l-5.2-5.2C24,28,26,24.3,26,20v-1H10v-2h16v-2H10V0z
			 M19.1,31.5l4.9,4.9V38H2v-1.6l4.9-4.9c1.8,1,3.9,1.5,6.1,1.5S17.3,32.5,19.1,31.5z M8,19H2V2h6V19z M2,21H24
			c-0.5,5.6-5.2,10-11,10C7.3,31,2.5,26.6,2,21z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Toilet
};
